<template>
  <v-form id="mailing_address_form" lazy-validation ref="address_form">
    <v-radio-group required dense v-model="address_type_option">
      <v-row>
        <v-col cols="4" class="pr-0">
          <v-radio dense>
            <template v-slot:label>
              <span style="font-size: 95%">Australian address</span>
            </template>
          </v-radio>
        </v-col>
        <v-col>
          <v-radio dense>
            <template v-slot:label>
              <span style="font-size: 95%">Standard address (include International)</span>
            </template>
          </v-radio>
        </v-col>
      </v-row>
    </v-radio-group>

        <!-- Australian input address -->
        <v-input v-if="getOption() == 0" required solo dense
          class="v-input v-input--dense theme--light v-text-field v-text-field--single-line v-text-field--solo v-text-field--is-booted v-text-field--enclosed v-text-field--placeholder"
        >
          <vue-google-autocomplete :country="['au']" id="address_autocomplete" placeholder="Start typing" v-on:placechanged="getAddressData"></vue-google-autocomplete>
        </v-input>
        <!-- Standard input address -->
        <div v-if="getOption() == 1">
          <v-row>
            <v-col>
              <v-text-field name="address" placeholder="Address" @change="updateAddress($event, 'address')" required solo dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field name="city" placeholder="City / Suburb" @change="updateAddress($event, 'city')" required solo dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field name="postcode" placeholder="Postcode / ZIP" @change="updateAddress($event, 'postcode')" required solo dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field name="state" placeholder="State / Province / Region" @change="updateAddress($event, 'state')" required solo dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field name="country" placeholder="Country" @change="updateAddress($event, 'country')" required solo dense></v-text-field>
            </v-col>
          </v-row>
        </div>

  </v-form>
</template>

<script>
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import {mapState} from 'vuex';
  export default {
    name: 'MailingComponent',
    props: {
      storedName: {
        type: String,
        required: true,
      },
    },
    components: {
      VueGoogleAutocomplete,
    },
    computed: {
      ...mapState('additional_services', {
        option_show: state => state[this.$props.storedName],
      }),
      address_type_option: {
        get() {
          return this.$store.state.additional_services[this.$props.storedName];
        },
        set(value) {
          this.$store.commit('additional_services/setMailingOption', {storedName: this.$props.storedName, value: value});
          this.$forceUpdate();
        },
      },
    },
    methods: {
      getAddressData: function (addressData) {
        console.log("Got address change");
        console.log(addressData);
        const address_data = {
          address: addressData.street_number + " " + addressData.route,
          city: addressData.locality,
          postcode: addressData.postal_code,
          state: addressData.administrative_area_level_1,
          country: addressData.country,
        }
        this.$store.commit('additional_services/setMailingAddress', {storedName: this.$props.storedName, value: address_data});
      },
      getOption: function() {
        return this.$store.state.additional_services[this.$props.storedName];
      },
      updateAddress: function(event, field) {
        console.log("Event fired", event, field);
        this.$store.commit('additional_services/updateMailingAddressField', {
          storedName: this.$props.storedName,
          field: field,
          value: event
        });
      },
    }
  }
</script>
<style scoped>
</style>
